export default __webpack_public_path__ + "static/media/cs-gif1.890a6263.gif";